import { useQuery } from '@tanstack/react-query';
import { API } from '@/utils/API';
import { StudySiteData } from '@/types/study';

const fetchSite = async (siteId: string): Promise<StudySiteData> => {
  const response = await API.authenticated.fetch(`/sites/${siteId}`);

  if (!response.ok) {
    throw new Error('Failed to fetch site');
  }

  return response.json();
};

export const useSite = (siteId: string) =>
  useQuery({
    queryKey: ['site', siteId],
    queryFn: () => fetchSite(siteId),
    staleTime: 0,
    gcTime: 5 * 60 * 1000,
  });
